<template>
  <div id="main">
    <div id="sonidos">
      <span class="title">loopsounds</span>
      <div class="flex-container">
        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">birds</div>
            <div class="controls flex-container">
              <div id="play-stop-birds" class="play-stop btn-success control-item" @click="playStop('birds')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="birds-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('birds')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="birds-volume" class="control-item volume btn_info"></div>
                <div id="birds-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('birds')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="birds" class="dontshow" loop>
              <source src="/src/assets/sounds/loops/morningbirds.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">ocean</div>
            <div class="controls flex-container">
              <div id="play-stop-ocean" class="play-stop btn-success control-item" @click="playStop('ocean')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="ocean-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('ocean')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="ocean-volume" class="control-item volume btn_info"></div>
                <div id="ocean-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('ocean')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="ocean" class="dontshow" loop>
              <source src="/src/assets/sounds/loops/ocean.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">whales</div>
            <div class="controls flex-container">
              <div id="play-stop-whales" class="play-stop btn-success control-item" @click="playStop('whales')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="whales-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('whales')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="whales-volume" class="control-item volume btn_info"></div>
                <div id="whales-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('whales')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="whales" class="dontshow" loop>
              <source src="/src/assets/sounds/loops/whales.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">rain</div>
            <div class="controls flex-container">
              <div id="play-stop-rain" class="play-stop btn-success control-item" @click="playStop('rain')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="rain-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('rain')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="rain-volume" class="control-item volume btn_info"></div>
                <div id="rain-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('rain')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="rain" class="dontshow" loop>
              <source src="/src/assets/sounds/loops/rain.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">storm</div>
            <div class="controls flex-container">
              <div id="play-stop-storm" class="play-stop btn-success control-item" @click="playStop('storm')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="storm-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('storm')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="storm-volume" class="control-item volume btn_info"></div>
                <div id="storm-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('storm')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="storm" class="dontshow" preload loop>
              <source src="/src/assets/sounds/loops/storm.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">wind</div>
            <div class="controls flex-container">
              <div id="play-stop-wind" class="play-stop btn-success control-item" @click="playStop('wind')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="wind-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('wind')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="wind-volume" class="control-item volume btn_info"></div>
                <div id="wind-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('wind')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="wind" class="dontshow" preload loop>
              <source src="/src/assets/sounds/loops/wind.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">fire</div>
            <div class="controls flex-container">
              <div id="play-stop-fire" class="play-stop btn-success control-item" @click="playStop('fire')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="fire-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('fire')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="fire-volume" class="control-item volume btn_info"></div>
                <div id="fire-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('fire')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="fire" class="dontshow" loop>
              <source src="/src/assets/sounds/loops/bonfire.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">crickets</div>
            <div class="controls flex-container">
              <div id="play-stop-crickets" class="play-stop btn-success control-item" @click="playStop('crickets')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="crickets-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('crickets')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="crickets-volume" class="control-item volume btn_info"></div>
                <div id="crickets-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('crickets')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="crickets" class="dontshow" preload loop>
              <source src="/src/assets/sounds/loops/crickets.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">murmur</div>
            <div class="controls flex-container">
              <div id="play-stop-murmur" class="play-stop btn-success control-item" @click="playStop('murmur')">
                <i class="mdi mdi-play"></i>
              </div>
              <div class="flex-container control-item">
                <div id="murmur-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('murmur')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="murmur-volume" class="control-item volume btn_info"></div>
                <div id="murmur-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('murmur')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="murmur" class="dontshow" loop>
              <source src="/src/assets/sounds/loops/murmur.mp3" type="audio/mpeg">browsernotaudio
            </audio>
          </div>
        </div>
      </div>
    </div>

    <div id="occasional">
      <span class="title">occasionalsounds</span>
      <div class="flex-container">
        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">tibetanbell</div>
            <div class="controls flex-container">
              <div class="flex-container control-item">
                <div id="tibetanbell-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('tibetanbell')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="tibetanbell-volume" class="control-item volume btn_info"></div>
                <div id="tibetanbell-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('tibetanbell')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="tibetanbell" class="dontshow" preload>
              <source src="/src/assets/sounds/occasional/tibetanbell.mp3" type="audio/mpeg">browsernotaudio
            </audio>
            <div class="control-item">
              <input
                type="text"
                id="tibetanbell-time"
                name="tibetanbell-time"
                size="1"
                maxlength="4"
                value="300"
                class="control-item time"
              >
              <div
                id="occasional-sound-tibetanbell"
                class="occasional-sound control-item btn btn-success btn-small"
                @click="ocasional('tibetanbell')"
              >
                <i class="mdi mdi-play"></i>
                <i class="mdi mdi-av-timer"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">magicgong</div>
            <div class="controls flex-container">
              <div class="flex-container control-item">
                <div id="magicgong-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('magicgong')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="magicgong-volume" class="control-item volume btn_info"></div>
                <div id="magicgong-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('magicgong')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="magicgong" class="dontshow" preload>
              <source src="/src/assets/sounds/occasional/magicgong.mp3" type="audio/mpeg">browsernotaudio
            </audio>
            <div class="control-item">
              <input
                type="text"
                id="magicgong-time"
                name="magicgong-time"
                size="1"
                maxlength="4"
                value="300"
                class="control-item time"
              >
              <div
                id="occasional-sound-magicgong"
                class="occasional-sound control-item btn btn-success btn-small"
                @click="ocasional('magicgong')"
              >
                <i class="mdi mdi-play"></i>
                <i class="mdi mdi-av-timer"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-item">
          <div class="loop-sound">
            <div class="sound-type">seagulls</div>
            <div class="controls flex-container">
              <div class="flex-container control-item">
                <div id="seagulls-less-volume" class="control-item less-volume btn-warning" @click="lessVolume('seagulls')">
                  <i class="mdi mdi-volume-minus"></i>
                </div>
                <div id="seagulls-volume" class="control-item volume btn_info"></div>
                <div id="seagulls-more-volume" class="control-item more-volume btn-primary" @click="moreVolume('seagulls')">
                  <i class="mdi mdi-volume-plus"></i>
                </div>
              </div>
            </div>
            <audio id="seagulls" class="dontshow" preload>
              <source src="/src/assets/sounds/occasional/seagulls.mp3" type="audio/mpeg">browsernotaudio
            </audio>
            <div class="control-item">
              <input
                type="text"
                id="seagulls-time"
                name="seagulls-time"
                size="1"
                maxlength="4"
                value="300"
                class="control-item time"
              >
              <div
                id="occasional-sound-seagulls"
                class="occasional-sound control-item btn btn-success btn-small"
                @click="ocasional('seagulls')"
              >
                <i class="mdi mdi-play"></i>
                <i class="mdi mdi-av-timer"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                sound: '',
                sounding : false,

                mStatusBirds: false,
                mStatusOcean: false,
                mStatusWhales: false,
                mStatusRain: false,
                mStatusStorm: false,
                mStatusWind: false,
                mStatusFire: false,
                mStatusCrickets: false,
                mStatusMurmur: false,

                mStatusTibetanbell: false,
                mStatusMagicGong: false,
                mStatusSeagulls: false,

                TibetanBellTimer: null,
                MagicGongTimer: null,
                SeagullsTimer: null,
            }
        },
        created() {

        },
        mounted() {
            $( ".less-volume" ).each(function () {
                var element = $(this).attr('id'); /*/#birds-play-stop*/
                var res = element.split("-");
                var soundId = "#" + res[0];
                var mSoundVol = $(soundId).prop("volume");
                $( soundId+"-volume" ).html(mSoundVol * 10);
            });
        },
        methods: {
            playStop(sound) {
                this.sounding = this.StatusSound(sound);
                if(this.sounding) {
                    $( "#"+sound )[0].play();
                    $( "#play-stop-"+sound ).removeClass("btn-success");
                    $( "#play-stop-"+sound ).addClass("btn-danger");
                    $( "#play-stop-"+sound ).html("<i class='mdi mdi-pause'></i>");
                } else {
                    $( "#"+sound )[0].pause();
                    $( "#play-stop-"+sound ).removeClass("btn-danger");
                    $( "#play-stop-"+sound ).addClass("btn-success");
                    $( "#play-stop-"+sound ).html("<i class='mdi mdi-play'></i>");
                }
            },
            ocasional(sound) {
                if (this.StatusSound(sound)) {
                    $( "#"+sound ).trigger('play');
                    $( "#occasional-sound-"+sound ).removeClass("btn-success");
                    $( "#occasional-sound-"+sound ).addClass("btn-danger");
                    $( "#occasional-sound-"+sound ).html("<i class='mdi mdi-stop'></i>");
                } else {
                    /*/ $( sound ).trigger('pause');*/
                    /*/ $( sound ).prop("currentTime", 0);*/
                    $( "#"+sound )[0].pause();
                    $( "#"+sound )[0].currentTime = 0;
                    $( "#occasional-sound-"+sound ).removeClass("btn-danger");
                    $( "#occasional-sound-"+sound ).addClass("btn-success");
                    $( "#occasional-sound-"+sound ).html("<i class='mdi mdi-play'></i><i class='mdi mdi-av-timer'></i>");
                }
            },
            playTibetanBell() {
                $( "#tibetanbell" )[0].play();
            },
            playMagicGong() {
                $( "#magicgong" )[0].play();
            },
            playSeagulls() {
                $("#seagulls")[0].play();
            },
            StatusSound(aSound) {
                var mStatusSound;
                switch (aSound) {
                    case "birds":
                        this.mStatusBirds = this.mStatusSound = !this.mStatusBirds;
                        break;

                    case "ocean":
                        this.mStatusOcean = this.mStatusSound = !this.mStatusOcean;
                        break;
                    case "whales":
                        this.mStatusWhales = this.mStatusSound = !this.mStatusWhales;
                        break;
                    case "rain":
                        this.mStatusRain = this.mStatusSound = !this.mStatusRain;
                        break;
                    case "storm":
                        this.mStatusStorm = this.mStatusSound = !this.mStatusStorm;
                        break;
                    case "wind":
                        this.mStatusWind = this.mStatusSound = !this.mStatusWind;
                        break;
                    case "fire":
                        this.mStatusFire = this.mStatusSound = !this.mStatusFire;
                        break;
                    case "crickets":
                        this.mStatusCrickets = this.mStatusSound = !this.mStatusCrickets;
                        break;
                    case "murmur":
                        this.mStatusMurmur = this.mStatusSound = !this.mStatusMurmur;
                        break;

                    case "tibetanbell":
                        this.mStatusTibetanbell = this.mStatusSound = !this.mStatusTibetanbell;
                        if (this.mStatusSound === true) {
                            let TibetanBellTime = $("#" + aSound + "-time").val();
                            this.TibetanBellTimer = setInterval(function () {
                                $( "#tibetanbell" )[0].play();
                                //this.playTibetanBell();
                            }, TibetanBellTime * 1000);
                        } else {
                            clearInterval(this.TibetanBellTimer);
                        }
                        break;
                    case "magicgong":
                        this.mStatusMagicGong = this.mStatusSound = !this.mStatusMagicGong;
                        if (this.mStatusSound === true) {
                            let MagicGongTime = $("#" + aSound + "-time").val();
                            this.MagicGongTimer = setInterval(function () {
                                $( "#magicgong" )[0].play();
                                //this.playMagicGong();
                            }, MagicGongTime * 1000);
                        } else {
                            clearInterval(this.MagicGongTimer);
                        }
                        break;
                    case "seagulls":
                        this.mStatusSeagulls = this.mStatusSound = !this.mStatusSeagulls;
                        if (this.mStatusSound === true) {
                            let SeagullsTime = $("#" + aSound + "-time").val();
                            this.SeagullsTimer = setInterval(function () {
                                $("#seagulls")[0].play();
                                //this.playSeagulls();
                            }, SeagullsTime * 1000);
                        } else {
                            clearInterval(this.SeagullsTimer);
                        }
                        break;
                    default:
                        this.mStatusSound = false;
                        break;
                }
                return this.mStatusSound;
            },
            GetVolume(aSound) {
                var mVolume = $(aSound).prop("volume");
                return mVolume;
            },
            lessVolume(sound) {
                var sound = "#" + sound;
                this.volumeDown(sound);
                var mSoundVol = this.GetVolume(sound);
                $( sound+"-volume" ).html(parseInt(mSoundVol * 10));
            },
            volumeDown(aSound) {
                var volume = $( aSound ).prop("volume") - 0.1;
                if (volume <= 0) {
                    volume = 0;
                }
                $( aSound ).prop("volume", volume);
            },
            moreVolume(sound) {
                var sound = "#" + sound;
                this.volumeUp(sound);
                var mSoundVol = this.GetVolume(sound);
                $( sound+"-volume" ).html(parseInt(mSoundVol * 10));
            },
            volumeUp(aSound) {
                var volume = $( aSound ).prop("volume") + 0.1;
                if (volume >= 1) {
                    volume = 1;
                }
                $( aSound ).prop("volume", volume);
            }
        }
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/Sounds.vue